import { BusinessEntityGate as AppComBusinessEntityGate } from '@zenbusiness/application-commons-business-entity';
import PageLoading from '@zenbusiness/zui/PageLoading';

import CheckBusinessEntity from './CheckBusinessEntity';

export default function BusinessEntityGate({ children }) {
  return (
    <AppComBusinessEntityGate loadingElement={<PageLoading />}>
      <CheckBusinessEntity>{children}</CheckBusinessEntity>
    </AppComBusinessEntityGate>
  );
}
